// extracted by mini-css-extract-plugin
module.exports = {"upload-tasks":"styles_upload-tasks__2ZHfQ","placeHolderShimmer":"styles_placeHolderShimmer__3LIOx","shimmer":"styles_shimmer__lPztM"};